import axios from '../axios/redditlikeApi'

const getPresignedUrl = data => axios.post('/presign-upload-url', data)

export default {
  getPresignedUrl
}
